import { render, staticRenderFns } from "./SuperRecommended.vue?vue&type=template&id=7f8768ac&scoped=true"
import script from "./SuperRecommended.vue?vue&type=script&lang=js"
export * from "./SuperRecommended.vue?vue&type=script&lang=js"
import style0 from "./SuperRecommended.vue?vue&type=style&index=0&id=7f8768ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8768ac",
  null
  
)

export default component.exports